import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

import { TDashboardMainFilter } from '../../types/dashboards';
import {
  TDashboardRegionFilterFullFilterPayload,
  TDashboardRegionFilterPayload,
  TDashboardRegionRepresentativeAbroadFilterPayload,
} from '../../types/regionDashboards';
import { REGION_DASHBOARDS_VES_ACTIONS_NAME, REGION_DASHBOARDS_VES_MUTATIONS_NAME } from './name';
import { TRegionDashboardStoreState } from './types';

import { TPaginationParams } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function getBaseRegionInfo(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardRegionFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getBaseRegionInfo,
      mutate: getLocalState(REGION_DASHBOARDS_VES_MUTATIONS_NAME.setBaseRegionInfo),
      name: getLocalState(REGION_DASHBOARDS_VES_ACTIONS_NAME.getBaseRegionInfo),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getRatingCards(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardRegionFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getRatingCards,
      mutate: getLocalState(REGION_DASHBOARDS_VES_MUTATIONS_NAME.setRatingCards),
      name: getLocalState(REGION_DASHBOARDS_VES_ACTIONS_NAME.getRatingCards),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getRatingList(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardRegionFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getRatingList,
      mutate: getLocalState(REGION_DASHBOARDS_VES_MUTATIONS_NAME.setRatingList),
      name: getLocalState(REGION_DASHBOARDS_VES_ACTIONS_NAME.getRatingList),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getIndicatorCards(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardRegionFilterFullFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getRegionStatistic,
      mutate: getLocalState(REGION_DASHBOARDS_VES_MUTATIONS_NAME.setIndicatorCards),
      name: getLocalState(REGION_DASHBOARDS_VES_ACTIONS_NAME.getIndicatorCards),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getDynamicCards(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardRegionFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getDynamicCards,
      mutate: getLocalState(REGION_DASHBOARDS_VES_MUTATIONS_NAME.setDynamicCards),
      name: getLocalState(REGION_DASHBOARDS_VES_ACTIONS_NAME.getDynamicCards),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getEventsCountByTypes(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardRegionFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getEventsCountByTypes,
      mutate: getLocalState(REGION_DASHBOARDS_VES_MUTATIONS_NAME.setEventsCountByTypes),
      name: getLocalState(REGION_DASHBOARDS_VES_ACTIONS_NAME.getEventsCountByTypes),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getAgreementsCountByTypes(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardRegionFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getAgreementsCountByTypes,
      mutate: getLocalState(REGION_DASHBOARDS_VES_MUTATIONS_NAME.setAgreementsCountByTypes),
      name: getLocalState(REGION_DASHBOARDS_VES_ACTIONS_NAME.getAgreementsCountByTypes),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getRepresentativeAbroadInfo(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardRegionRepresentativeAbroadFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getRepresentativeAbroadInfo,
      mutate: getLocalState(REGION_DASHBOARDS_VES_MUTATIONS_NAME.setRepresentativeAbroadInfo),
      name: getLocalState(REGION_DASHBOARDS_VES_ACTIONS_NAME.getRepresentativeAbroadInfo),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getRepresentativeAbroadInfoTable(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TBaseFilterPayload<TDashboardMainFilter & TPaginationParams>,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getRepresentativeAbroadInfoTable,
      name: getLocalState(REGION_DASHBOARDS_VES_ACTIONS_NAME.getRepresentativeAbroadInfoTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}
